import { render, staticRenderFns } from "./PartsNav.vue?vue&type=template&id=27387d1c&"
import script from "./PartsNav.vue?vue&type=script&lang=js&"
export * from "./PartsNav.vue?vue&type=script&lang=js&"
import style0 from "./PartsNav.vue?vue&type=style&index=0&id=27387d1c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports